import React from "react";
import { withNavBars } from "../../HOCs";
import FacilityManagerDashboard from "./facilityManagerDashboard";


class FacilityManagerDashboardParent extends React.Component {
    render() {
        return <FacilityManagerDashboard {...this.props} />;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(FacilityManagerDashboardParent, props);